
//Live chat
  function onReady(initialData) {
    LiveChatWidget.call("hide")
    // Chat Widget is ready
    var state = initialData.state;
    var customerData = initialData.customerData;

    // var el = document.getElementById('tooltip_portal_container');
    // console.log(el)
    // debugger;  
  }

  LiveChatWidget.on('ready', onReady)

  function onVisibilityChanged(data) {
  switch (data.visibility) {
    case "maximized":
      break;
    case "minimized":
        // LiveChatWidget.call("hide")
        
        chatBotEl.style.display = "unset";    
        if(isMin)   
            chatButton.style.display = "flex";
                 
        setTimeout(() => {
            LiveChatWidget.call("hide");
        }, 100);
      break;
    case "hidden":
      break;
  }
}

LiveChatWidget.on('visibility_changed', onVisibilityChanged)

let serverUrl = "https://bot.danielalain.com/"; //服务器地址
const styleSet = {
    // bubbleBackground: 'rgba(0, 0, 255, .1)',
    // paddingRegular:"20",
    backgroundColor: "#f6f6f6",
    bubbleBackground: "f6f6f6",// "#fcfcfd",
    bubbleFromUserBackground: "#e6e6e6", //rgba(0, 255, 0, .1)',

    //botAvatarImage: '<your bot avatar URL>',
    botAvatarInitials: 'DA',
    botAvatarBackgroundColor: "#000",
    // userAvatarImage: '<your user avatar URL>',
    // userAvatarInitials: 'WC',
    //rootHeight: '100%',
    //rootWidth: '100%',

    suggestedActionLayout: "flow",//stacked",//"flow",
    suggestedActionBorderWidth: 1,
    suggestedActionBorderColor: "#e6e6e6",// "#9edcf7",
    suggestedActionTextColor: "#262626",
    // suggestedActionBorderRadius: "10px",
    suggestedActionHeight: 40,
    typingAnimationDuration: 5000,
    bubbleMaxWidth: 600,

    sendBoxBackground: "#f6f6f6",
    // enableUploadThumbnail:false,
    hideUploadButton:true
};


let webChatEl = document.getElementById('webchat-body');
let isMin = localStorage.getItem("chat_isMin") != "0";

let chatBotEl = document.getElementById('webchat-bot');
let isGettingHistory = false;

if (window.location.href.endsWith('/retail-locator'))
    isMin=true;

function initChat(token) {
    // webChatEl.innerHTML="";
    chatContainer.style.display = "flex";
    chatButton.style.display = "none";
    // 打开模态时
    document.body.classList.add('modal-open');

    if (isMin) {
        isMin = false;
        return;
    }

    // Create store 
    const store = window.WebChat.createStore({}, ({ dispatch }) => next => action => {
        // if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
        //   dispatch({
        //     type: 'WEB_CHAT/SEND_EVENT',
        //     payload: {
        //       name: 'webchat/join'
        //     }
        //   });
        // }

        if (!isGettingHistory && action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {
            const event = new Event('webchatincomingactivity');

            event.data = action.payload.activity;
            window.dispatchEvent(event);
        }

        //  if (action.type === 'WEB_CHAT/SET_SUGGESTED_ACTIONS'){
        //     debugger
        //  }

        // if (action.type === 'SET_SUGGESTED_ACTIONS') {
        //     debugger
        //     const { suggestedActions } = action.payload;

        //     if (suggestedActions && suggestedActions.actions.length) {
        //         // Inject them into the transcript as a bot message
        //         dispatch({
        //         type: 'DIRECT_LINE/INCOMING_ACTIVITY',
        //         payload: {
        //             activity: {
        //             type: 'message',
        //             from: { role: 'bot' },
        //             text: 'Suggested actions:',
        //             attachments: [
        //                 {
        //                 contentType: 'application/vnd.microsoft.card.hero',
        //                 content: {
        //                     text: 'Choose one:',
        //                     buttons: suggestedActions.actions.map(a => ({
        //                     type: a.type,
        //                     title: a.title,
        //                     value: a.value
        //                     }))
        //                 }
        //                 }
        //             ]
        //             }
        //         }
        //         });
        //     }
        // }

        return next(action);
    });

    // Persist activities to localStorage
    store.subscribe(() => {
        const state = store.getState();
        localStorage.setItem('chatHistory', JSON.stringify(state.activities.filter(x=>x.type !='typing' && x.type != "transfer")));
    });

    // Rehydrate activities from localStorage
    const savedActivities = JSON.parse(localStorage.getItem('chatHistory') || '[]');
    
    var i=0;
    isGettingHistory=true;
    savedActivities.forEach(activity =>{
        i++;
        store.dispatch({
            type: 'DIRECT_LINE/INCOMING_ACTIVITY',
            payload: { activity }
        })

        if(i == savedActivities.length && activity.suggestedActions?.actions?.length >0){
            store.dispatch({
                type: "WEB_CHAT/SET_SUGGESTED_ACTIONS",
                payload: { suggestedActions: activity.suggestedActions.actions }
            })
        }
    });
    isGettingHistory=false;

    window.addEventListener('webchatincomingactivity', ({ data }) => {
        //   console.log(`Received an activity of type "${data.type}":`);
        //   console.log(data);
        if (data.type == "transfer") {
            // LiveChatWidget.init();
            LiveChatWidget.call("maximize");
            chatBotEl.style.display = "none";
        }
    });


    // Create DirectLine connection
    const savedConversationId = localStorage.getItem('conversationId');
    const directLine = window.WebChat.createDirectLine({
        token: token,
        conversationId: savedConversationId || undefined,
        userId: savedConversationId || undefined,
    });

    // Save conversationId once connected
    directLine.connectionStatus$.subscribe(status => {
        if (status === 2) { // Connected
            // debugger
            localStorage.setItem('conversationId', directLine.conversationId);
        }
    });

    // Watch connection status
    directLine.connectionStatus$.subscribe(status => {
    if (status === 4) { // Ended
        showSessionExpiredMessage();
    }
    });

    window.WebChat.renderWebChat(
        {
            directLine: directLine,
            sendTypingIndicator: true,
            styleOptions: styleSet,
            store
            // userID: 'YOUR_USER_ID',
            // username: 'Web Chat User',
            // locale: 'en-US'
        },
        webChatEl
    );
}

function showSessionExpiredMessage() {
    console.log('session timeout.');
    resetChat();
    // if(store){
    //     store.dispatch({
    //         type: 'DIRECT_LINE/INCOMING_ACTIVITY',
    //         payload: {
    //         activity: {
    //             type: 'message',
    //             id: 'expired-' + Date.now(),
    //             timestamp: new Date().toISOString(),
    //             from: { role: 'bot' },
    //             text: '⚠️ Your session has expired. Please refresh or reconnect.'
    //         }
    //         }
    //     });
    // }
    // else
    //     resetChat()  
}

//聊天按钮
var chatButton = document.getElementById('chat-button');

var chatButton1 = document.getElementById('chatButton1');

var chatContainer = document.getElementById('webchat-container');
chatButton.addEventListener('click', () => {
    isMin=false;
    localStorage.setItem("chat_isMin","0");

    if (token)
        initChat(token);
    else {
        resetChat()
    }
})

if(chatButton1){
    chatButton1.addEventListener('click', () => {
        isMin=false;
        localStorage.setItem("chat_isMin","0");
        if (token)
            initChat(token);
        else {
            resetChat()
        }
    })
}


//最小化按钮
var chatMinBtn = document.getElementById('chat-min-button');
chatMinBtn.addEventListener('click', () => {
    chatContainer.style.display = "none";
    chatButton.style.display = "flex";
    isMin = true;    
    localStorage.setItem("chat_isMin","1");

    // 关闭模态时
    document.body.classList.remove('modal-open');
})

var clearModal = document.getElementById('chat-clear-modal');
//对话框头清除按钮
var chatRestartConfirm = document.getElementById('chat-restart-button');
chatRestartConfirm.addEventListener('click', () => {
    if (clearModal) {
        clearModal.style.display = "flex";
    }
});
//确认清除按钮
var chatRestartBtn = document.getElementById('modal-restart-button');
chatRestartBtn.addEventListener('click', () => {
    isMin = false;
    localStorage.setItem("chat_isMin","0");
    resetChat();
    clearModal.style.display = "none";
});
//取消清除按钮
var chatCancelBtn = document.getElementById('modal-cancel-button');
chatCancelBtn.addEventListener('click', () => {
    clearModal.style.display = "none";
})

let token = localStorage.getItem('da_ai_token');
// console.log(token)
// debugger
if(!isMin){
    if (token)
        initChat(token);
    else {
        resetChat()
    }
}


function resetChat(){
    localStorage.removeItem('chatHistory');
    localStorage.removeItem('conversationId');
    fetch(`${serverUrl}api/bot-token`).then(res => { return res.text(); }).then(result => {
        // Restore conversationId if available
        token = result;
        localStorage.setItem('da_ai_token', result);
        // console.log(result)
        initChat(result)
    })
}

//Talk to person

var talkButton=document.getElementById('talk-to-person-button');
talkButton.addEventListener('click',()=>{
    LiveChatWidget.call("maximize");
    chatBotEl.style.display = "none";
})

// [].forEach.call(document.getElementsByTagName('meta'), ({ content, name }) => console.log(`${name}: ${content}`));